
import { defineComponent, PropType, ref, computed } from "vue";
import TUIViewer from "../../components/application/TUIViewer.vue";
import {
  Choice,
  QuestionForm
} from "../../../../domain/entities/search-form/question_form";

export default defineComponent({
  name: "QuestionFormSingleAnswer",
  components: { TUIViewer },
  props: {
    question: {
      type: Object as PropType<{ question: QuestionForm }>,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const selectedFeedback = ref<number | null>(
      props.question.question.answerId || null
    );

    const feedbackOptions = computed(() =>
      (props.question.question.singleChoices || []).map((c: Choice) => ({
        value: c.id,
        label: c.answerText
      }))
    );

    function getSelected() {
      return selectedFeedback.value;
    }

    return {
      selectedFeedback,
      feedbackOptions,
      getSelected
    };
  }
});
